import "./index.css";
import React from "react";
import { Spin } from "antd";

interface TypeContainerProps<T = React.ReactNode> {
  extra?: T;
  children?: T;
  loading?: boolean;
}

/**
 * @name Container UI容器
 * @description 与业务逻辑无关
 */
const Container: React.FC<TypeContainerProps> = ({
  extra,
  loading,
  children,
}) => {

  // 如果是iframe模式，限制容器高度为500px，并添加滚动条
  const urlParams = new URLSearchParams(window.location.search);
  const isIframeMode = urlParams.get("mode") === "iframe";
  const containerClassName = isIframeMode
    ? "guideline-select guideline-select-iframe-adjuster"
    : "guideline-select";

  return (
    <div className={containerClassName}>
      <div className="guideline-select-header">
        <span>Select guidelines</span>
        <div>{extra}</div>
      </div>
      <div>
        <Spin spinning={loading}>{children}</Spin>
      </div>
    </div>
  );
};

export default Container;
